import React from "react";

import "../styles/layout.css";
import { AnimatePresence, motion } from "framer-motion";

export default function Transition({ children, location }) {
  const duration = 0.35;

  const variants = {
    initial: {
      opacity: 0,
    },
    enter: {
      opacity: 1,
      transition: {
        duration: duration,
        delay: duration,
        when: "beforeChildren",
      },
    },
    exit: {
      opacity: 0,
      transition: { duration: duration },
    },
  };

  return (
    <AnimatePresence initial={false}>
      <motion.div
        key={location.pathname}
        className={location.pathname}
        variants={variants}
        initial="initial"
        animate="enter"
        exit="exit"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
